import {PeriodicTask} from "./PeriodicTask";

const Defaults = {
	periodMs: 2000,
	delayMs: 10000,
	target: '/'
}

export function waitSiteStartTimer(opts: { target?: string, periodMs?: number, delayMs?: number } = {}) {
	const finalOpts = {
		...Defaults,
		...opts
	}

	let waitPending = false;
	new PeriodicTask(function () {
		if (waitPending) return;

		waitPending = true;
		console.info('check site is started');
		fetch('/')
			.then(resp => {
				if (resp.status == 200 || resp.status == 425) {
					document.location.href = finalOpts.target;
					waitPending = false;
				} else {
					console.info(`server returns ${resp.status} ${resp.statusText}`)
				}
			})
			.finally(() => waitPending = false);
	}, {periodMs: finalOpts.periodMs, enabled: true, delayMs: finalOpts.delayMs});
}